import { useState, useCallback, useRef } from 'react';

/**
 * Custom hook for virtual scrolling functionality
 * Only renders visible items in large lists for better performance
 */
export const useVirtualList = <T>(
    items: T[], 
    itemHeight: number, 
    containerHeight: number
) => {
    const [scrollTop, setScrollTop] = useState(0);
    const scrollElementRef = useRef<HTMLDivElement>(null);

    const startIndex = Math.floor(scrollTop / itemHeight);
    const endIndex = Math.min(
        startIndex + Math.ceil(containerHeight / itemHeight) + 1,
        items.length
    );

    const visibleItems = items.slice(startIndex, endIndex);
    const totalHeight = items.length * itemHeight;
    const offsetY = startIndex * itemHeight;

    const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
        setScrollTop(e.currentTarget.scrollTop);
    }, []);

    return {
        scrollElementRef,
        visibleItems,
        totalHeight,
        offsetY,
        handleScroll,
        startIndex,
        endIndex
    };
};